import { render, staticRenderFns } from "./OrganizationNameBubble.vue?vue&type=template&id=3caa692f&scoped=true&"
import script from "./OrganizationNameBubble.vue?vue&type=script&lang=ts&"
export * from "./OrganizationNameBubble.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationNameBubble.vue?vue&type=style&index=0&id=3caa692f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caa692f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
